import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useTitleV2 = (title: string = '') => {
  const location = useLocation();
  const documentDefined = typeof document !== 'undefined';

  useEffect(() => {
    if (documentDefined) {
      document.title = `${title} | Medeloop Account`;
    }
  }, [location]);
};
